export default __webpack_public_path__ + "static/media/4_Tim_Headshot.82071910.png";